import {
  DailyRoutineConsistencyOption,
  EligibleAppleWatchBreakpointOption,
  Experiment,
  getBucket,
  ProductKey,
  QuizDataInput,
  SnoozeOption,
  WakeUpTimeConsistencyOption,
  WearWatchToBedOption,
  WhatToTrackWithDeviceOption,
  WhichWearableBreakpointOption,
} from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { getState } from '@src/app/srv/store.service'

export function isB1InSignupTest(): boolean {
  const assignment = getState().experiment.assignments[Experiment.B1_IN_SIGNUP]
  if (!assignment) return false
  return getBucket(assignment) === 'test'
}

export const sectionRoutineB1InSignup = [
  QuizPage.naturalMethod,
  QuizPage.yourMeasuringDevice,
  QuizPage.whichWearable,
  QuizPage.sleepAndLifeStyleInfo,
  QuizPage.wakeUpTimeConsistency,
  QuizPage.snooze,
  QuizPage.dailyRoutineConsistency,
  QuizPage.fitResult,
  QuizPage.deviceResult,
]

const wearsWatchToBedB1InSignup = [WearWatchToBedOption.yes, WearWatchToBedOption.noButOpenToIt]

export function getRecommendedDeviceB1InSignup(
  data: QuizDataInput,
  termometerKey: ProductKey,
): ProductKey {
  const {
    eligibleAppleWatch,
    whichWearable,
    wearWatchToBed,
    wakeUpTimeConsistency,
    snooze,
    dailyRoutineConsistency,
    whatToTrack,
  } = data

  // Recommend  Apple Watch if:
  // User has eligible Apple Watch (if user answer includes "Apple Watch" on question "Do you own any of these device(s)?"
  // AND “Yes” on question “Does it have temperatur sensors?”)
  // AND user wears watch to bed (if user answered, "Yes, (...)" OR “No, but I’m open (...)” on question "Do you wear your watch to bed?”)
  const isAppleWatchEligible =
    whichWearable?.includes(WhichWearableBreakpointOption.appleWatch) &&
    eligibleAppleWatch === EligibleAppleWatchBreakpointOption.yes &&
    wearWatchToBed &&
    wearsWatchToBedB1InSignup.includes(wearWatchToBed)

  // Recommend Oura Ring if:
  // User owns Oura Ring (if user answer includes "Oura Ring” on question "Do you own any of these device(s)")
  // OR user answers 'My fertility and and cycle, plus) to "What to track with new device?" question

  const isOuraRingEligible =
    whichWearable?.includes(WhichWearableBreakpointOption.ouraRing) ||
    whatToTrack === WhatToTrackWithDeviceOption.cycleAndMetrics

  // Recommend NC° Therm if:
  // User wakes up the same time most days (if user answered "I wake up the same time most days" on question "How consistent is your wake-up time?”)
  // AND user never snoozes (if user answered "No, never" on question "Do you snooze when you wake up?”)
  // AND user has a set routine most days (if user answered "Yes, I have a set routine most days" on question "Do you have a consistent daily routine?”)

  const isThermometerEligible =
    wakeUpTimeConsistency === WakeUpTimeConsistencyOption.sameTime &&
    snooze === SnoozeOption.never &&
    dailyRoutineConsistency === DailyRoutineConsistencyOption.setRoutine

  if (isAppleWatchEligible) {
    return ProductKey.APPLE_WATCH
  }

  if (isOuraRingEligible) {
    return ProductKey.OURA_RING_DISCOUNT
  }

  if (isThermometerEligible) {
    return termometerKey
  }
  return ProductKey.B1
}
